export const MessageReaded = [
    `<path 
          d="M773.495 279.073l-61.528-61.528-276.876 276.876 61.528 61.528 276.876-276.876zM958.077 217.545l-461.46 465.855-184.584-184.584-61.528 61.528 246.112 246.112 527.383-527.383-65.923-61.528zM0 560.344l246.112 246.112 61.528-61.528-246.112-246.112-61.528 61.528z"
      />`,
    "0 0 1024 1024",
  ];
  
  export const MessageSended = [
    `<path 
          d="M958.077 217.545l-461.46 465.855-184.584-184.584-61.528 61.528 246.112 246.112 527.383-527.383-65.923-61.528zM0 560.344v0z"
      />`,
    "0 0 1024 1024",
  ];
  
  export const MessageDelete = [
    `<path 
          d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
      />`,
    "0 0 512 512",
  ];

  export const Attach = [
    `<path 
          d="M20.6475 10.6158L11.8855 19.3778C9.93289 21.3304 6.76706 21.3304 4.81444 19.3778C2.86182 17.4252 2.86182 14.2594 4.81444 12.3068L12.9462 4.17503C14.313 2.80819 16.5291 2.80819 17.8959 4.17503C19.2628 5.54186 19.2628 7.75794 17.8959 9.12478L10.1024 16.9183C9.32132 17.6994 8.05499 17.6994 7.27394 16.9183C6.4929 16.1373 6.49289 14.8709 7.27394 14.0899L14.468 6.89585" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
      />`,
    "0 0 24 24"
  ]

  export const Send = [
    `<path 
          d="M3.3938 2.20468C3.70395 1.96828 4.12324 1.93374 4.4679 2.1162L21.4679 11.1162C21.7953 11.2895 22 11.6296 22 12C22 12.3704 21.7953 12.7105 21.4679 12.8838L4.4679 21.8838C4.12324 22.0662 3.70395 22.0317 3.3938 21.7953C3.08365 21.5589 2.93922 21.1637 3.02382 20.7831L4.97561 12L3.02382 3.21692C2.93922 2.83623 3.08365 2.44109 3.3938 2.20468ZM6.80218 13L5.44596 19.103L16.9739 13H6.80218ZM16.9739 11H6.80218L5.44596 4.89699L16.9739 11Z" fill="#000000"
      />`,
    "0 0 24 24"
  ]

  export const Microphone = [
    `<path 
          d="M15.965 22h0.238c2.78 0 4.797-2.050 4.797-4.874v-11.919c0-2.92-2.108-5.207-4.798-5.207h-0.237c-2.738 0-4.965 2.336-4.965 5.207v11.919c0 2.779 2.135 4.874 4.965 4.874zM13 5.207c0-1.768 1.33-3.207 2.965-3.207h0.238c1.595 0 2.797 1.379 2.797 3.207v11.919c0 1.718-1.124 2.874-2.798 2.874h-0.237c-1.746 0-2.965-1.181-2.965-2.874zM25 11c-0.552 0-1 0.448-1 1v4.159c0 5.95-2.124 8.842-6.492 8.842h-2.973c-5.713 0-6.535-4.808-6.535-8.841v-4.159c0-0.552-0.448-1-1-1s-1 0.448-1 1v4.159c0 6.89 2.872 10.841 8.535 10.841h0.465v3h-5c-0.552 0-1 0.448-1 1s0.448 1 1 1h12c0.552 0 1-0.448 1-1s-0.448-1-1-1h-5v-3h0.508c3.874 0 8.492-1.881 8.492-10.842v-4.159c0-0.552-0.448-1-1-1z" fill="#000000" 
      />`,
    "0 0 32 32"
  ]

  export const Cancel = [
    `<path
          d="M19.587 16.001l6.096 6.096c0.396 0.396 0.396 1.039 0 1.435l-2.151 2.151c-0.396 0.396-1.038 0.396-1.435 0l-6.097-6.096-6.097 6.096c-0.396 0.396-1.038 0.396-1.434 0l-2.152-2.151c-0.396-0.396-0.396-1.038 0-1.435l6.097-6.096-6.097-6.097c-0.396-0.396-0.396-1.039 0-1.435l2.153-2.151c0.396-0.396 1.038-0.396 1.434 0l6.096 6.097 6.097-6.097c0.396-0.396 1.038-0.396 1.435 0l2.151 2.152c0.396 0.396 0.396 1.038 0 1.435l-6.096 6.096z"  fill="#000000"
      />`,
    "0 0 32 32"
  ]